import { NavLink } from 'react-router'
import { cn } from '../../lib/cn.js'
import { useAuth } from '../../lib/auth.js'
import styles from './AdminSidebar.module.css'

type NavItem = { to: string; label: string; icon: string; end?: boolean }
type NavGroup = { group: string; items: NavItem[] }
type NavEntry = NavItem | NavGroup

const NAV_ITEMS: NavEntry[] = [
  { to: '/admin', label: '대시보드', icon: '📊', end: true },
  { to: '/admin/users', label: '유저 관리', icon: '👥' },
  {
    group: 'AI',
    items: [
      { to: '/admin/history', label: '히스토리', icon: '📋' },
      { to: '/admin/ai-models', label: 'AI 모델', icon: '⚙️' },
      { to: '/admin/ai-test', label: 'AI 테스트', icon: '🧪' },
      { to: '/admin/prompt-blocks', label: '프롬프트 블록', icon: '🧩' },
    ],
  },
  { to: '/admin/payments', label: '결제 내역', icon: '💳' },
  { to: '/admin/credit-transactions', label: '크레딧 내역', icon: '🪙' },
  { to: '/admin/settings', label: '앱 설정', icon: '🔧' },
]

interface AdminSidebarProps {
  open: boolean
  onClose: () => void
}

export function AdminSidebar({ open, onClose }: AdminSidebarProps) {
  const { logout } = useAuth()

  return (
    <>
      {open && <div className={styles.overlay} onClick={onClose} />}
      <aside className={cn(styles.root, open && styles.open)}>
        <div className={styles.logo}>
          <span className={styles.logoText}>Cugumi</span>
          <span className={styles.logoBadge}>Admin</span>
        </div>
        <nav className={styles.nav}>
          {NAV_ITEMS.map((entry) => {
            if ('group' in entry) {
              return (
                <div key={entry.group} className={styles.group}>
                  <span className={styles.groupLabel}>{entry.group}</span>
                  {entry.items.map((item) => (
                    <NavLink
                      key={item.to}
                      to={item.to}
                      className={({ isActive }) => cn(styles.link, isActive && styles.linkActive)}
                      onClick={onClose}
                    >
                      <span className={styles.linkIcon}>{item.icon}</span>
                      {item.label}
                    </NavLink>
                  ))}
                </div>
              )
            }
            return (
              <NavLink
                key={entry.to}
                to={entry.to}
                end={entry.end}
                className={({ isActive }) => cn(styles.link, isActive && styles.linkActive)}
                onClick={onClose}
              >
                <span className={styles.linkIcon}>{entry.icon}</span>
                {entry.label}
              </NavLink>
            )
          })}
        </nav>
        <div className={styles.footer}>
          <button className={styles.logoutButton} onClick={logout}>
            로그아웃
          </button>
        </div>
      </aside>
    </>
  )
}
